import PerfectScrollbar from 'perfect-scrollbar';

const init = () => {
    const container = document.querySelector('#scrollbar');
    if(!container){
        return 0;
    }
    const ps = new PerfectScrollbar(container, {
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20
    });
    
}

export default {
    init
}